import jingtai from '../assets/presets/ra68_zoomer_jingtai.txt?url'
import huochairen from '../assets/presets/ra68_zoomer_huochairen.txt?url'

export const PRESET_CONFIGS = {
  /**
   * Zoomer
   */
  TITLT: 'zoomer',
  JINGTAIVA_RA68_ZOOMER: jingtai,
  HUOCHAIREN_RA68_ZOOMER: huochairen,
} as const
